import { render, staticRenderFns } from "./FirstRunHint.vue?vue&type=template&id=72faa352&"
import script from "./FirstRunHint.vue?vue&type=script&lang=js&"
export * from "./FirstRunHint.vue?vue&type=script&lang=js&"
import style0 from "./FirstRunHint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports